// Classic PDP Try-On (ported from old theme custom.js)
(function () {
  if (document.querySelector('.pdp-revamp--active')) return;

  // YMK SDK init
  window.ymkAsyncInit = function () {
    var isMobile = window.innerWidth < 768;
    window.YMK.init({
      autoOpen: false,
      width: isMobile ? window.innerWidth : 300,
      height: isMobile ? Math.round(window.innerHeight * 0.6) : 600,
    });

    window.YMK.addEventListener("opened", function () {
      const defaultSwatch = document.querySelector(".swatch-element.active, .swatch-element.selected");
      if (defaultSwatch) {
        const sku = defaultSwatch.getAttribute("data-variant-sku");
        if (sku) {
          window.YMK.applyMakeupBySku(sku);
        }
      }

      setTimeout(function () {
        if (window.innerWidth < 768) {
          const iframe = document.querySelector("#YMK-module iframe");
          const wrapped = document.querySelector(".product-wrapped");
          if (iframe && wrapped) {
            wrapped.style.height = iframe.offsetHeight + "px";
          }
        }
      }, 500);
    });

    window.YMK.addEventListener("reset", function () {});
    window.YMK.addEventListener("compare", function () {});
    window.YMK.addEventListener("videoLoaded", function () {});
    window.YMK.addEventListener("photoLoaded", function () {});
    window.YMK.addEventListener("loaded", function () {});
    window.YMK.addEventListener("shadeFinderComplete", function (r) {});
  };

  // Try On Module Code (from old theme)
  document.addEventListener('DOMContentLoaded', function () {
    const parent = document.querySelector('body');
    const TryonBtn = document.querySelectorAll('.tryBtn');
    const windwInnerWidth = window.innerWidth;

    window.addEventListener('scroll', () => {
      if (windwInnerWidth < 768) {
        const scrollHeight = window.scrollY;
        const TryONModuleImage = document.querySelector('.activeImg');
        const TryOnModuleBtns = document.querySelector('.tryBtns');
        
        if (scrollHeight <= 300) {
          if (TryONModuleImage) TryONModuleImage.style.display = 'none';
          if (TryOnModuleBtns) TryOnModuleBtns.style.display = 'flex';
        } else {
          if (TryONModuleImage) TryONModuleImage.style.display = 'block';
          if (TryOnModuleBtns) TryOnModuleBtns.style.display = 'none';
        }
      }
    });

    const YMKInitModule = () => {
      window.scrollTo(0, 0);
      if (!window.YMK) {
        console.error("MakeupAR SDK failed to load; virtual try-on is unavailable.");
        return;
      }

      var mob = window.innerWidth < 768;
      window.YMK.init({
        autoOpen: true,
        width: mob ? window.innerWidth : 300,
        height: mob ? Math.round(window.innerHeight * 0.6) : 600,
      });
      document.body.classList.add('tryOnOpen');
      
      document.querySelectorAll('.tryONModuleBox').forEach((item) => {
        item.style.display = 'block';
      });
      
      TryonBtn.forEach((item) => {
        item.classList.add('closeTryOn');
        item.textContent = 'Close';
        item.classList.remove('tryItonBtn');
      });
    };

    const YMKRemoveModule = () => {
      window.scrollTo(0, 0);
      document.body.classList.remove('tryOnOpen');
      
      document.querySelectorAll('.tryONModuleBox').forEach((item) => {
        item.style.display = 'none';
      });
      
      TryonBtn.forEach((item) => {
        item.classList.remove('closeTryOn');
        item.textContent = 'Try On';
        item.classList.add('tryItonBtn');
      });
    };

    parent.addEventListener('click', (event) => {
      if (event.target.classList.contains('tryItonBtn') || event.target.classList.contains('trynowImage')) {
        YMKInitModule();

        const tryNowImage = document.querySelector('.trynowImage');
        if (tryNowImage) {
          tryNowImage.classList.remove('activeImg');
          tryNowImage.style.display = "none";
        }

        const closeNowImage = document.querySelector('.CloseNowImage');
        if (closeNowImage) {
          closeNowImage.classList.add('activeImg');
          closeNowImage.style.display = "block";
        }
      } else if (event.target.classList.contains('closeTryOn') || event.target.classList.contains('CloseNowImage')) {
        YMKRemoveModule();

        const closeNowImage = document.querySelector('.CloseNowImage');
        if (closeNowImage) {
          closeNowImage.classList.remove('activeImg');
          closeNowImage.style.display = "none";
        }

        const tryNowImage = document.querySelector('.trynowImage');
        if (tryNowImage) {
          tryNowImage.classList.add('activeImg');
          tryNowImage.style.display = "block";
        }
      }
    });

    // Swatch click handler
    const swatches = document.querySelectorAll(".swatch-element");
    const tryOnCardTitle = document.querySelectorAll(".try-on-open-selected-variant-box-title");
    const tryOnCardName = document.querySelectorAll(".try-on-open-selected-variant-box-variant-name");
    const tryOnCardPrice = document.querySelectorAll(".try-on-open-selected-variant-box-variant-price");
    const tryOnCardImg = document.querySelectorAll(".try-on-open-selected-variant-box-img img");
    const tryOnCardBtnPrice = document.querySelectorAll(".try-on-open-atc .m_productPrice");
    const tryOnCardBtnId = document.querySelectorAll(".try-on-open-atc .product-form input[name='id']");
    const tryOnCardATCBtn = document.querySelectorAll(".try-on-open-atc .atcMainBtn");
    const tryOnCardATCBtnTitle = document.querySelectorAll(".try-on-open-atc .atcMainBtn .m_atcBtn .txt.removeUnavailable");

    swatches.forEach(function (swatch) {
      swatch.addEventListener("click", function () {
        document.querySelectorAll('.try-on-open-swatchLbl-variant-box').forEach(el => el.classList.remove('selected'));
        this.querySelector('.try-on-open-swatchLbl-variant-box')?.classList.add('selected');

        const swatchSKU = this.getAttribute("data-variant-sku");
        const variantID = this.getAttribute("data-variant-id");
        const swatchIMG = this.getAttribute("data-variant-img");
        const swatchPrice = this.getAttribute("data-variant-price");
        const productTitle = this.getAttribute("data-product-title");
        const swatchTitle = this.getAttribute("data-value");
        const swatchAvailability = this.getAttribute("data-variant-availability");

        if (swatchSKU && window.YMK) {
          window.YMK.applyMakeupBySku(swatchSKU);
        }

        if (swatchAvailability !== 'true') {
          tryOnCardATCBtn.forEach(btn => {
            btn.classList.add('sold-out');
            btn.setAttribute('disabled', 'disabled');
          });
          tryOnCardATCBtnTitle.forEach(btn => { btn.textContent = 'SOLD OUT'; });
        } else {
          tryOnCardATCBtn.forEach(btn => {
            btn.classList.remove('sold-out');
            btn.removeAttribute('disabled');
          });
          tryOnCardATCBtnTitle.forEach(btn => { btn.textContent = 'ADD TO CART'; });
        }

        tryOnCardTitle.forEach(el => el.textContent = productTitle);
        tryOnCardName.forEach(el => el.textContent = swatchTitle);
        tryOnCardPrice.forEach(el => el.textContent = swatchPrice);
        tryOnCardBtnPrice.forEach(el => el.textContent = swatchPrice);
        tryOnCardImg.forEach(el => el.src = swatchIMG);
        tryOnCardBtnId.forEach(el => el.value = variantID);
      });
    });

    // Apply default SKU after YMK loads
    const swatch_elementDefault = document.querySelector(".swatch-element.default");
    if (swatch_elementDefault) {
      const swatch_elementDefaultSKU = swatch_elementDefault.getAttribute("data-variant-sku");
      
      const oldLog = console.log;
      console.log = function (...args) {
        if (args.some(a => typeof a === "string" && a.includes("face_detect_model_path"))) {
          setTimeout(() => {
            if (window.YMK && swatch_elementDefaultSKU) {
              window.YMK.applyMakeupBySku(swatch_elementDefaultSKU);
            }
          }, 1000);
        }
        oldLog.apply(console, args);
      };
    }
  });
})();
